import { useContext } from 'react';
import { OngoingOrderContext } from '../../providers/OngoingOrderProvider';

export default function useOngoingOrder() {
  return useContext(OngoingOrderContext);
}
